import __var_0__ from '@stdlib/vendor/debug.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var logger = __var_0__;


// VARIABLES //

var debug = logger( 'path:xpos' );


// MAIN //

/**
* Returns a function to map values to x coordinate values.
*
* @private
* @returns {Function} map function
*/
function get() {
	/* eslint-disable no-invalid-this */
	var scale = this.xScale;
	return xPos;

	/**
	* Maps a value to a x coordinate value.
	*
	* @private
	* @param {Array} d - datum
	* @returns {number} pixel value
	*/
	function xPos( d ) {
		var px = scale( d[0] );
		debug( 'Value: %d => Pixel: %d.', d[0], px );
		return px;
	}
}


// EXPORTS //
export default get;
